import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../css_files/Master/AddPartsMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";
import Select from "react-select";

function AddServiceReportMapping({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  servicemappingupdatedata,
}) {
  const [boilerSeriesData, setBoilerSeriesData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [serviceReportMappingData, setServiceReportMappingData] = useState({
    SeriesGroup: triggerupdate ? servicemappingupdatedata?.seriesGroup : "",
    ServiceReportMasterCategories: triggerupdate
      ? servicemappingupdatedata?.serviceReportMasterCategories
      : [],
    ReportType: triggerupdate ? servicemappingupdatedata?.type : "",
  });
  const [reloadDropdown, setreloadDropdown] = useState(false);
  const [rotatedropdownicon, setrotatedropdownicon] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState(false);
  const { setExpiredSession } = useContext(triggerscroll);
  const [showCloneWindow, setShowCloneWindow] = useState(false);
  const [cloneDropdown, setCloneDropdown] = useState([]);
  const [cloneData, setCloneData] = useState({
    SeriesGroup: "",
    Type: "",
  });

  useEffect(() => {
    setrotatedropdownicon(true);

    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/GetBoilerSeriesDropdown`
      )
      .then((res) => {
        setBoilerSeriesData(
          res.data
            ?.map((x) => ({
              label: `${x?.head} - ${x?.label}`,
              value: x?.value,
            }))
            ?.reduce((acc, curr) => {
              const result = curr.label.replace(/\d+/g, "");
              if (!acc.some((x) => x.label === result)) {
                acc.push({
                  label: result,
                  value: result,
                });
              }
              return acc;
            }, [])
        );

        axiosInstance
          .get(
            `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetServiceReportMasterCategoriesDropdown`
          )
          .then((res) => {
            setCategoryData(res.data);
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetSeriesGroupDropdown`
              )
              .then((res) => {
                setCloneDropdown(
                  res.data?.map((x) => ({
                    label: x,
                    value: x,
                  }))
                );
                setrotatedropdownicon(false);
              })
              .catch(console.log);
          })
          .catch(console.log);
      })
      .catch(console.log);
  }, [reloadDropdown]);

  function handleSubmit(e) {
    e.preventDefault();

    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/UpdateServiceReport`;
      axiosInstance
        .put(url, {
          Id: servicemappingupdatedata.id,
          ...serviceReportMappingData,
          Type: serviceReportMappingData.ReportType,
        })
        .then((res) => {
          toast.success(res.data, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/CreateServiceReport`;
      axiosInstance
        .post(url, {
          ...serviceReportMappingData,
          Type: serviceReportMappingData.ReportType,
        })
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error(error?.response?.data, {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }

  function handleCloneSubmit() {
    axiosInstance
      .post(
        `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetClonedData`,
        cloneData
      )
      .then((res) => {
        if (res.status === 200) {
          setServiceReportMappingData({
            ...serviceReportMappingData,
            ReportType: res.data.type,
            ServiceReportMasterCategories:
              res.data.serviceReportMasterCategories,
          });
          setShowCloneWindow(false);
        }
      })
      .catch(console.log);
  }

  useEffect(() => {
    if (showCloneWindow === false) {
      setCloneData({
        Type: "",
        SeriesGroup: "",
      });
    }
  }, [showCloneWindow]);
  return (
    <form className="add-parts-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Boiler Head - Series{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <Select
            isSearchable
            options={boilerSeriesData}
            onChange={(values) => {
              if (values) {
                setServiceReportMappingData({
                  ...serviceReportMappingData,
                  SeriesGroup: values?.value,
                });
              }
            }}
            value={boilerSeriesData?.find(
              (x) => x?.value === serviceReportMappingData.SeriesGroup
            )}
            isClearable
            isDisabled={triggerupdate}
            required
            placeholder="Enter Boiler Head-Series"
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            menuPlacement="top"
          />
          <i
            class={`fa-solid fa-rotate-right ${
              rotatedropdownicon && "fa-spin"
            }`}
            title="refresh dropdown"
            onClick={() => setreloadDropdown(!reloadDropdown)}
          ></i>
        </aside>
      </blockquote>
      <blockquote>
        <label>
          Report Type{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <aside>
          <mark>
            <p>Servicing</p>
            <input
              type="radio"
              name="supply"
              onChange={(e) =>
                setServiceReportMappingData({
                  ...serviceReportMappingData,
                  ReportType: "Servicing",
                })
              }
              disabled={triggerupdate}
              checked={serviceReportMappingData.ReportType === "Servicing"}
              required
            />
          </mark>
          <mark>
            <p>Commissioning</p>
            <input
              disabled={triggerupdate}
              type="radio"
              name="supply"
              onChange={(e) =>
                setServiceReportMappingData({
                  ...serviceReportMappingData,
                  ReportType: "Commissioning",
                })
              }
              checked={serviceReportMappingData.ReportType === "Commissioning"}
              required
            />
          </mark>
        </aside>
      </blockquote>
      {serviceReportMappingData.ReportType === "Commissioning" && (
        <blockquote>
          <label>
            Select Categories
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <aside>
            <Select
              isSearchable
              options={categoryData}
              onChange={(values) => {
                if (values) {
                  setServiceReportMappingData({
                    ...serviceReportMappingData,
                    ServiceReportMasterCategories: values,
                  });
                }
              }}
              menuPlacement="top"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              value={serviceReportMappingData.ServiceReportMasterCategories}
              isClearable
              required
              isMulti
              getOptionLabel={(x) => x?.name}
              getOptionValue={(x) => String(x?.id)}
              placeholder="Select Categories"
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
                placeholder: (base) => ({
                  ...base,
                  color: "black",
                }),
                control: (base, state) => ({
                  ...base,
                  borderColor: "black",
                  "&:hover": {
                    borderColor: "black",
                  },
                  boxShadow: "none",
                }),
                singleValue: (base) => ({
                  ...base,
                  color: "black",
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: "black",
                  "&:hover": {
                    color: "black",
                  },
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  backgroundColor: "black",
                }),
                noOptionsMessage: (base) => ({
                  ...base,
                  color: "black",
                }),
              }}
            />
            <i
              class={`fa-solid fa-rotate-right ${
                rotatedropdownicon && "fa-spin"
              }`}
              title="refresh dropdown"
              onClick={() => setreloadDropdown(!reloadDropdown)}
            ></i>
          </aside>
        </blockquote>
      )}
      <aside>
        <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
        &nbsp;
        <button
          type="button"
          onClick={() => {
            setShowCloneWindow(!showCloneWindow);
          }}
          hidden={triggerupdate}
        >
          {showCloneWindow ? "Close" : "Clone"}
        </button>
      </aside>
      <CloseForm close={setshowaddform} />
      {showCloneWindow && (
        <>
          <blockquote>
            <label>
              Boiler Head - Series{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <aside>
              <Select
                isSearchable
                options={cloneDropdown}
                onChange={(values) => {
                  if (values) {
                    setCloneData({
                      ...cloneData,
                      SeriesGroup: values?.value,
                    });
                  }
                }}
                placeholder="Select Boiler Head-Series"
                isClearable
                menuPlacement="top"
                styles={{
                  container: (base) => ({
                    ...base,
                    width: "100%",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "black",
                  }),
                  control: (base, state) => ({
                    ...base,
                    borderColor: "black",
                    "&:hover": {
                      borderColor: "black",
                    },
                    boxShadow: "none",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "black",
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: "black",
                    "&:hover": {
                      color: "black",
                    },
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: "black",
                  }),
                  noOptionsMessage: (base) => ({
                    ...base,
                    color: "black",
                  }),
                }}
              />
              <i
                class={`fa-solid fa-rotate-right ${
                  rotatedropdownicon && "fa-spin"
                }`}
                title="refresh dropdown"
                onClick={() => setreloadDropdown(!reloadDropdown)}
              ></i>
            </aside>
          </blockquote>
          <blockquote>
            <label>
              Report Type{" "}
              <sup>
                <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
              </sup>
            </label>
            <aside>
              <mark>
                <p>Servicing</p>
                <input
                  type="radio"
                  onChange={(e) =>
                    setCloneData({
                      ...cloneData,
                      Type: "Servicing",
                    })
                  }
                  checked={cloneData.Type === "Servicing"}
                />
              </mark>
              <mark>
                <p>Commissioning</p>
                <input
                  type="radio"
                  onChange={(e) =>
                    setCloneData({
                      ...cloneData,
                      Type: "Commissioning",
                    })
                  }
                  checked={cloneData.Type === "Commissioning"}
                />
              </mark>
            </aside>
          </blockquote>
          <button type="button" onClick={handleCloneSubmit}>
            Submit
          </button>
        </>
      )}
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddServiceReportMapping;
